import React from 'react';
import {motion} from "framer-motion"
import {fadeIn} from "../variants"
import img1 from "../assets/portfolio-img1.png"
import img2 from "../assets/portfolio-img2.png"
import img3 from "../assets/portfolio-img3.png"

const Work = () => {
  return(
    <section id="work" className='section'>
      <div className='container mx-auto '>
        <div className='flex flex-col lg:flex-row gap-x-10' >
          <motion.div
          variants={fadeIn('right', 0.5)}
          initial={'hidden'}
          whileInView={'show'}
          viewport={{once:false, amount:.3}}
          className='flex-1 flex flex-col gap-y-12 mb-10 lg:mb-0' >
            {/* text */}
            <div>
              <h2
                className='h2 leading-tight text-accent'
              >My latest<br/>work</h2>
              <p className='max-w-sm mb-16' >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
              <button className='btn btn-sm' >View all projects</button>
            </div>
            {/* image */}
            <div className='group overflow-hidden relative border-1 border-white/50 rounded-l' >
              {/* overlay */}
              <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300' ></div>
              {/* image */}
              <img className='group-hover:scale-125 transition-all duration-500' src={img1} />
              <div className='transition-all absolute -bottom-full left-12 group-hover:bottom-24 duration-500 z-50' >
                <span className='text-gradient' >UI/UX Design</span>
              </div>
              <div className='transition-all absolute -bottom-full left-12 group-hover:bottom-14 duration-700 z-50' >
                <span className='text-3xl text-white ' >Project title</span>
              </div>
            </div>
          </motion.div>
          <motion.div
          variants={fadeIn('left', 0.5)}
          initial={'hidden'}
          whileInView={'show'}
          viewport={{once:false, amount:.3}}
          className='flex-1 flex flex-col gap-y-10 ' >
            
            <div className='group overflow-hidden relative border-1 border-white/50 rounded-l' >
              {/* overlay */}
              <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300' ></div>
              {/* image */}
              <img className='group-hover:scale-125 transition-all duration-500' src={img2} />
              <div className='transition-all absolute -bottom-full left-12 group-hover:bottom-24 duration-500 z-50' >
                <span className='text-gradient' >UI/UX Design</span>
              </div>
              <div className='transition-all absolute -bottom-full left-12 group-hover:bottom-14 duration-700 z-50' >
                <span className='text-3xl text-white ' >Project title</span>
              </div>
            </div>

            
            <div className='group overflow-hidden relative border-1 border-white/50 rounded-l' >
              {/* overlay */}
              <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300' ></div>
              {/* image */}
              <img className='group-hover:scale-125 transition-all duration-500' src={img3} />
              <div className='transition-all absolute -bottom-full left-12 group-hover:bottom-24 duration-500 z-50' >
                <span className='text-gradient' >UI/UX Design</span>
              </div>
              <div className='transition-all absolute -bottom-full left-12 group-hover:bottom-14 duration-700 z-50' >
                <span className='text-3xl text-white ' >Project title</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
};

export default Work;
